type ErrorRecord = Record<string, unknown>;

const asRecord = (value: unknown): ErrorRecord | null =>
  value && typeof value === 'object' ? (value as ErrorRecord) : null;

export const getBankStatementImportErrorRowId = (error: unknown): string | null => {
  const root = asRecord(error);
  const response = asRecord(root?.data) ?? root;
  const payload = asRecord(response?.data) ?? response;
  const rowId = payload?.RowId ?? payload?.rowId;
  return typeof rowId === 'string' && rowId.length > 0 ? rowId : null;
};
